const { OPEN_EDIT_EXP, CLOSE_EDIT_EXP } = require("../types");

const INITIAL_STATE = {
  editExpIsOpen: false,

  expTitle: '',
  expShortDes: '',
  expCity: '',
  expDate: '',
  expDes: '',
  expLocationLat: '',
  expLocationLng: '',
  expPhoto1: '',
  expPhoto2: '',
  expPhoto3: '',
  expPhoto4: '',
  expPhoto5: '',
  uploadImages: false
};

const editExpReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action

  switch(type) {
    case OPEN_EDIT_EXP:
      return {
        ...state,
        expId: payload._id,
        expTitle: payload.expTitle,
        expShortDes: payload.expShortDes,
        expCity: payload.expCity,
        expDate: payload.expDate,
        expDes: payload.expDes,
        expLocationLat: payload.expLocationLat,
        expLocationLng: payload.expLocationLng,
        expPhoto1: payload.expPhotos[0],
        expPhoto2: payload.expPhotos[1],
        expPhoto3: payload.expPhotos[2],
        expPhoto4: payload.expPhotos[3],
        expPhoto5: payload.expPhotos[4],

        editExpIsOpen: true
      }
    case CLOSE_EDIT_EXP: 
      return {
        ...state,
        editExpIsOpen: false,

        expTitle: '',
        expShortDes: '', 
        expCity: '',
        expDate: '',
        expDes: '',
        expLocationLat: '',
        expLocationLng: '',
        expPhoto1: '',
        expPhoto2: '',
        expPhoto3: '',
        expPhoto4: '',
        expPhoto5: '',
        uploadImages: false
      }
    default:
      return state; 
  }
}


export default editExpReducer;